var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 6.792,16.992 h 15.296 c 0.608,0 1.024,-0.384 1.024,-0.992 0,-0.608 -0.416,-0.992 -1.024,-0.992 H 6.696 c -0.608,0 -0.992,0.384 -0.992,0.992 0,0.608 0.512,0.992 1.088,0.992 z m 9.312,9.312 c 0.288,0 0.512,-0.096 0.704,-0.32 l 9.28,-9.28 c 0.416,-0.416 0.416,-0.992 0,-1.408 L 16.808,5.984 C 16.392,5.6 15.816,5.6 15.4,5.984 c -0.416,0.384 -0.384,1.024 0,1.408 L 24.008,16 15.4,24.608 c -0.384,0.384 -0.384,0.992 0,1.376 0.192,0.224 0.416,0.32 0.704,0.32 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.759dfd18708d62423edb2cfa166e88fe.svg";
export { ForwardRef as ReactComponent };